module.exports = __webpack_public_path__ + "img/assistant-avatar.1c69394.png";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/assistant-avatar.png
// module id = ./assets/assistant/assistant-avatar.png
// module chunks = 10